import React, { useEffect, useRef, useState } from 'react';
import './pane.css';
import { Typography } from "@mui/material";
import { PhoneOff } from 'lucide-react';
import GradualTextComponent from "../GradualTextComponent/GradualTextComponent";
import { CONTENT } from '../../config/landingPageContent';

const Message = ({ text, timestamp, show, sender }) => (
  <li className={`message-block ${show ? 'show' : ''}`}>
    <span className="message-content">
      {sender === 'copilot' ? (
        <GradualTextComponent text={text} wordsPerStep={7} stepInterval={100} />
      ) : (
        <span dangerouslySetInnerHTML={{ __html: text }} />
      )}
    </span>
    <span className="message-time">{timestamp}</span>
  </li>
);

const AnimatedChatComponent = ({ messages, videoSrc, variant = 'default' }) => {
    const content = CONTENT[variant] || CONTENT.default;
    const [visibleMessages, setVisibleMessages] = useState([]);
    const [activePane, setActivePane] = useState('interviewer');
    const interviewerPaneRef = useRef(null);
    const copilotPaneRef = useRef(null);

    useEffect(() => {
        messages.forEach((message, index) => {
            setTimeout(() => {
                setVisibleMessages(prev => {
                    if (!prev.find(m => m.text === message.text && m.timestamp === message.timestamp)) {
                        return [...prev, { ...message, show: false }];
                    }
                    return prev;
                });

                setTimeout(() => {
                    setVisibleMessages(prev =>
                        prev.map(m =>
                            m.text === message.text && m.timestamp === message.timestamp
                                ? { ...m, show: true }
                                : m
                        )
                    );
                }, 50);

                const targetPane =
                    message.sender === 'interviewer' ? interviewerPaneRef.current :
                        message.sender === 'copilot' ? copilotPaneRef.current :
                            null;
                if (targetPane && message.sender === 'interviewer') {
                    targetPane.scrollTop = targetPane.scrollHeight;
                }
            }, index * 1000);
        });

        // Switch to copilot pane after a delay
        const switchToCopilotTimeout = setTimeout(() => {
            setActivePane('copilot');
        }, messages.length * 1000); // Switch after all messages are displayed plus 2 seconds

        return () => clearTimeout(switchToCopilotTimeout);
    }, [messages]);

    return (
        <div className="chat-interface">
            <div className={`interviewer-pane ${activePane === 'interviewer' ? 'active' : ''}`} ref={interviewerPaneRef}>
                <div className="interviewer-title">{content.demo.interviewer}</div>
                <div className="content-container">
                    <video src={videoSrc} className="avatar-v" loop autoPlay playsInline muted></video>
                    <ul className="transcribe-block">
                        {visibleMessages
                            .filter(m => m.sender === 'interviewer')
                            .map((m, i) => (
                                <Message key={i} {...m} />
                            ))}
                    </ul>
                </div>
                <div className="hang-up-button-container">
                    <button
                        className="hang-up-button"
                        aria-label="Hang up"
                    >
                        <PhoneOff size={28} />
                    </button>
                </div>
            </div>
            <div className={`copilot-pane ${activePane === 'copilot' ? 'active' : ''}`} ref={copilotPaneRef}>
                <div className="header-container">
                    <div className="icon-left">
                    </div>
                    <Typography variant="h6" component="h3" className="copilot-title">
                        {content.demo.copilot}
                    </Typography>

                </div>
                <header className="Hint-header">
                    <div className="dark-container">
                        {activePane === 'copilot' && visibleMessages
                            .filter((m) => m.sender === 'copilot')
                            .map((m, i) => (
                                <div key={i} className="response-container">
                                    <div className="response-segment">
                                        <Message {...m} />
                                    </div>
                                </div>
                            ))}
                    </div>
                </header>
            </div>
        </div>
    );
};

export default AnimatedChatComponent;
